// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__1WS-m","title":"Widget_title__31ERG"};